/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, {useEffect, useState} from "react";
import {useFormik} from "formik";
import {Table} from 'reactstrap';
import * as Yup from "yup";
import ICSelect from "../../../components/form/selectInput";

import _ from "lodash";

import Label from "../../../components/label";
import Button from "../../../components/button";
import IconButton from "../../../components/iconButton";

const TreatmentPlanSelectionForm = props => {
  const [selectedTreatmentTypes, setSelectedTreatmentTypes] = useState([]);
  const [drugList, setDrugList] = useState([]);
  const [isSubmitButtonVisible, setIsSubmitButtonVisible] = useState(true);

  // const [disableTypeName, setDisableTypeName] = useState(false);

  const erectileDysfunctionDrugs = [{
    "_id": "Sildenafil",
    "val": "Sildenafil"
  }, {
    "_id": "Tadalafil",
    "val": "Tadalafil"
  }, {
    "_id": "Avanafil (Spedra)",
    "val": "Avanafil (Spedra)"
  }, {
    "_id": "Vardenafil (Levitra)",
    "val": "Vardenafil (Levitra)"
  }];

  const prematureEjaculationDrugs = [{
    "_id": "Dapoxetine (SSRI)",
    "val": "Dapoxetine (SSRI)"
  }, {
    "_id": "Paroxetine (SSRI)",
    "val": "Paroxetine (SSRI)"
  }, {
    "_id": "Fluoxetine (SSRI)",
    "val": "Fluoxetine (SSRI)"
  }, {
    "_id": "Sertraline (SSRI)",
    "val": "Sertraline (SSRI)"
  }, {
    "_id": "Clomipramine (TCA)",
    "val": "Clomipramine (TCA)"
  }]

  const sleepLossDrugs = [{
    "_id": "Melatonin (Circadin)",
    "val": "Melatonin (Circadin)"
  }];

  const hairLossDrugs = [{
    "_id": "Finasteride",
    "val": "Finasteride"
  }, {
    "_id": "Hair Regrowth Treatment",
    "val": "Hair Regrowth Treatment",
  }];

  const hairRegrowthDrugOptions = [{
    "_id": "Men's Regaine Extra Strength Solution",
    "val": "Men's Regaine Extra Strength Solution"
  }, {
    "_id": "Men's Regaine Extra Strength Foam",
    "val": "Men's Regaine Extra Strength Foam",
  }];


  const formik = useFormik({
    initialValues: {
      typeName: "",
      drug: "",
      brand: "",
    },
    validationSchema: Yup.object({
      typeName: Yup.string().required("Please select type"),
      drug: Yup.string().required("Please select option"),
      brand: Yup.string().when("drug", {
        is:  "Hair Regrowth Treatment",
        then: Yup.string().required("Please select brand")
      })
    }),
    onSubmit: (values) => {
      console.log("Handle submit: ", values);
      const dataObj = {
        typeName: formik.values.typeName,
        drug: formik.values.drug,
        brand: formik.values.brand,
      };
      const isAlreadyIncluded = _.filter(selectedTreatmentTypes, (o) => {
        return o.typeName === dataObj.typeName && o.drug === dataObj.drug && o.brand === dataObj.brand;
      });

      console.log("Filter Items: ", isAlreadyIncluded);

      if (isAlreadyIncluded.length) {
        return;
      }
      handleFormSubmit(dataObj);
    }
  });

  const handleFormSubmit = (formValues) => {
    setSelectedTreatmentTypes(prev => {
      console.log("Previous values: ", prev);
      const mergeValues = [...prev, formValues];
      return mergeValues;
    });
  }

  const deleteSelectedType = (index) => {
    var array = [...selectedTreatmentTypes]; // make a separate copy of the array
    // var index = array.indexOf(e.target.value)

    array.splice(index, 1);
    setSelectedTreatmentTypes(prev => [...array]);

  }

  const handleDoneButton = () => {
    props.addSelectedType(selectedTreatmentTypes);
  }

  useEffect(() => {
    if (props.assessmentType) {
      formik.setFieldValue("typeName", props.assessmentType);
      formik.handleChange("typeName");
      switch (props.assessmentType) {
        case "Sleep Loss":
          setDrugList(sleepLossDrugs);
          break;
        case "Hair Loss":
          setDrugList(hairLossDrugs);
          break;
        case "Premature Ejaculation":
          setDrugList(prematureEjaculationDrugs);
          break;
        case "Erectile Dysfunction":
          setDrugList(erectileDysfunctionDrugs);
          break;
      }
    }
  }, [props.assessmentType]);

  useEffect(() => {
    if (props.selectedType.length) {
      setSelectedTreatmentTypes(props.selectedType);
    }
  }, []);

  return (
    <>
      <Label className="secondary-font pl-2 pt-2" title="Step 1: Select Treatment Plan"/>
      <form className="row p-0 m-0" onSubmit={formik.handleSubmit}>
        {isSubmitButtonVisible && (
          <>
            {(!selectedTreatmentTypes.length || props.assessmentType === "Hair Loss") && <div className="col-sm-4">
              <Label className="gray small" title="Select Type" required={true}/>
              <ICSelect
                label=""
                placeholder="Select Type"
                id="typeName"
                name="typeName"
                useId="_id"
                useValue="val"
                disabled={true}
                items={[
                  {_id: "Erectile Dysfunction", val: "Erectile Dysfunction"},
                  {_id: "Premature Ejaculation", val: "Premature Ejaculation"},
                  {_id: "Sleep Loss", val: "Sleep Loss"},
                  {_id: "Hair Loss", val: "Hair Loss"},
                ]}
                value={formik.values.typeName}
                onBlur={formik.handleBlur}
                handleChange={val => {
                  formik.values.typeName = val;
                  formik.setFieldValue("typeName", val);
                  // formik.handleChange("typeName");
                  // formik.handleChange("drugName");
                }}
                error={formik.touched.typeName && formik.errors.typeName ? true : false}
                helperText={
                  formik.touched.typeName && formik.errors.typeName
                    ? formik.errors.typeName
                    : ""
                }
              />
              {formik.errors.typeName && formik.touched.typeName ? (
                <Label title="Please select type" className="small error"/>
              ) : (
                ""
              )}
            </div>}

            {((!selectedTreatmentTypes.length || props.assessmentType === "Hair Loss") && drugList.length) ? (
              <div className="col-sm-4">
                <Label className="gray small" title="Select Drug" required={true}/>
                <ICSelect
                  label=""
                  placeholder="Select Drug"
                  id="drug"
                  name="drug"
                  useId="_id"
                  useValue="val"
                  items={drugList}
                  value={formik.values.drug}
                  onBlur={formik.handleBlur}
                  handleChange={val => {
                    formik.values.drug = val;
                    formik.setFieldValue("drug", val);
                    formik.setFieldValue("brand", "");
                  }}
                  error={formik.touched.drug && formik.errors.drug ? true : false}
                  helperText={
                    formik.touched.drug && formik.errors.drug
                      ? formik.errors.drug
                      : ""
                  }
                />
                {formik.errors.drug && formik.touched.drug ? (
                  <Label title="Please select drug" className="small error"/>
                ) : (
                  ""
                )}
              </div>
            ) : ("")
            }

            {formik.values.drug === "Hair Regrowth Treatment" ? (
              <div className="col-sm-4">
                <Label className="gray small" title="Select Brand" required={true}/>
                <ICSelect
                  label=""
                  placeholder="Select Brand"
                  id="brand"
                  name="brand"
                  useId="_id"
                  useValue="val"
                  items={hairRegrowthDrugOptions}
                  value={formik.values.brand}
                  onBlur={formik.handleBlur}
                  handleChange={val => {
                    console.log({val})
                    formik.setFieldValue("brand", val);
                  }}
                  error={formik.touched.brand && formik.errors.brand ? true : false}
                  helperText={
                    formik.touched.brand && formik.errors.brand
                      ? formik.errors.brand
                      : ""
                  }
                />
                {formik.errors.drug && formik.touched.drug ? (
                  <Label title="Please select brand" className="small error"/>
                ) : (
                  ""
                )}
              </div>
            ) : ("")
            }

            {(!selectedTreatmentTypes.length || props.assessmentType === "Hair Loss") &&
              <div className="col-sm-12 text-center mt-3">
                <Button type="submit" className="ml-3" title="Add Selected Drug"/>
              </div>}
          </>
        )
        }
      </form>

      {selectedTreatmentTypes.length ? (
        <div className="row p-0 m-0 mt-4 selected-type-container">
          <div className="col-sm-12">
            <Table hover>
              <thead>
              <tr>
                <th>Selected Type</th>
                <th>Selected Drug</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              {selectedTreatmentTypes.map((selectedType, index) => {
                return (
                  <tr key={index}>
                    <td><Label title={`${selectedType.typeName}`} className="w-100 mb-0"/></td>
                    <td><Label title={`${(selectedType.drug ? selectedType.drug : '-')
                    + (selectedType.brand ? " - " + selectedType.brand : "")
                    }`} className="w-100"/></td>
                    <td>
                      <IconButton title="" className="only-icon" icon="fas fa-times"
                                  clickEvent={() => deleteSelectedType(index)}
                      />
                    </td>
                  </tr>
                )
              })
              }
              <tr>
              </tr>
              </tbody>
            </Table>
          </div>
          <div className="mt-4 col-sm-12 text-center">
            <Button type="button" title="Next" clickEvent={handleDoneButton}/>
          </div>
        </div>
      ) : ('')
      }
    </>
  );
};

export default TreatmentPlanSelectionForm;
